import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'

interface BillingAlertModalProps {
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  updateBillingAmount: (obj: any) => Promise<any>
  alertUpdateLoading: boolean
}

const BillingAlertModal = (props: BillingAlertModalProps) => {
  const { showModal, setShowModal, updateBillingAmount, alertUpdateLoading } = props

  const [disable, setDisabled] = useState(true)
  const [timeInterval, setTimeInterval] = useState('')

  const handleModalClose = async () => {
    const obj = {
      billingAlertAmount: +timeInterval,
    }
    const res = await updateBillingAmount(obj)
    if (res?.status === 200) {
      setShowModal(false)
    }
  }
  const validateField = (val: string) => {
    if (val) {
      setTimeInterval(val)
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Set amount limit to alert you via email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {alertUpdateLoading && (
          <div className='d-flex justify-content-center mb-5'>
            <div className='spinner-border text-primary'>
              <span className='sr-only'>Saving...</span>
            </div>
          </div>
        )}

        <div className='d-flex flex-row gap-4'>
          <input
            className='form-control'
            style={{ marginRight: 5 }}
            id='amount'
            type='number'
            onChange={(e) => validateField(e.target.value)}
          />
          <button
            type='button'
            className='btn secondary-button'
            onClick={handleModalClose}
            disabled={disable}
          >
            Save
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default BillingAlertModal
